<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 订单打印
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<el-input placeholder="标签码" class="handle-input mr10" v-model="QRFont" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-search" @click="clearSelection()">清空选择</el-button>
				<el-button type="primary" icon="el-icon-position" @click="Print()">跳转打印页面</el-button>
			</div>
			<el-table :data="pingjiList" border class="table" ref="multipleTable" header-cell-class-name="table-header" :row-key="getRowKey"
				style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center" :reserve-selection="true">
				</el-table-column>
				<el-table-column prop="QRFont" label="商品标签码" align="center" min-width="150"></el-table-column>
				<el-table-column prop="Name" label="商品名称" align="center" min-width="200"></el-table-column>
				<el-table-column prop="State" label="商品状态" width="90" align="center">
					<template #default="scope">
						<div v-for="(item) in stateList" :key="item">
							<el-tag v-if="scope.row.State==item.value">
								{{item.name}}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="Surface" label="Surface" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Edges" label="Edges" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Corners" label="Corners" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Centering" label="Centering" align="center" min-width="100"></el-table-column>
				<el-table-column prop="LastScore" label="总分" align="center" min-width="100"></el-table-column>
				<el-table-column fixed="right" label="操作" width="100" align="center" style="background-color: red;">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next" :current-page="pageIndex"
					:page-sizes="[5,15, 30 , 45]" :page-size="pageSize" :total="pageTotal"
					@current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
			</div>

			<!-- 查看弹出框 -->
			<el-dialog :title="title" v-model="isPrint" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="商品标签码" prop="QRFont">
						<el-input v-model="ruleForm.QRFont" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="商品名称" prop="Name">
						<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="是否带星" prop="isStar">
						<el-input v-model="ruleForm.isStar" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="PE/CE" prop="PE">
						<el-select v-model="ruleForm.PE" placeholder="PE或者CE" style="width: 100%;"
							:disabled="isdisabled" clearable>
							<el-option :label="item.label" :value="item.value" v-for="item in checkList"
								:key="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Surface" prop="Surface">
						<el-input v-model="ruleForm.Surface" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Edges" prop="Edges">
						<el-input v-model="ruleForm.Edges" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Corners" prop="Corners">
						<el-input v-model="ruleForm.Corners" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Centering" prop="Centering">
						<el-input v-model="ruleForm.Centering" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="总分" prop="LastScore">
						<el-input v-model="ruleForm.LastScore" :disabled="isdisabled"></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="isPrint = false">取 消</el-button>
					</span>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import print from 'td-print'
	import axios from 'axios'
	import qs from 'qs'
	export default {
		data() {
			return {
				checkList: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: 'PE'
					}, {
						value: 2,
						label: 'CE'
					}, {
						value: 3,
						label: 'PE,CE'
					},
				],
				photolist: '',
				QRFont: '', //标签码
				yulanList: [],
				OrderCode: '',
				isPrint: false,
				title: '',
				goodsList: [],
				pingjiList: [],
				ruleForm: {},
				token: localStorage.getItem('access_token'),
				roleid: localStorage.getItem('RoleId'),
				Id: localStorage.getItem('Id'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				editVisible: false,
				isdisabled: false,

				value2: [],
				memberList: [], //会员列表
				distributorList: [], //经销商列表
				kuaipingList: [{
						Id: 1,
						Name: '普通'
					},
					{
						Id: 2,
						Name: '加急'
					}
				],
				startTime: '', //开始时间
				endTime: '', //结束时间
				state: '',
				isprice: false,
				isphoto: false,
				photoList: [],
				showphoto: false,
				stateList: [{
					name: '待打印',
					value: 5
				}, {
					name: '已打印',
					value: 6
				}],
				printId: ''
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getRowKey(row) {
				return row.Id
			},
			pdfBtn() {
				this.$confirm('是否打印, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					print(this.$refs.bigbox)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消打印'
					});
				});
			},
			clearSelection() {
				this.$refs.multipleTable.clearSelection();
			},
			handleSelectionChange(val) {
				this.yulanList = val
				if (this.yulanList.length >= 36) {
					// 截取前20位
					this.yulanList = val.slice(0, 36);
					// 截取20位之后的数组  禁止选中
					let tempArr = val.slice(36);
					if (tempArr.length !== 0) {
						tempArr.forEach((ele) => {
							this.$refs.multipleTable.toggleRowSelection(ele, false);
						});
						this.$message.error('一次最多打印36个商品标签')
					}
				}
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getData()
			},
			//打开打印订单的商品列表
			Print() {
				localStorage.setItem('shuju',JSON.stringify(this.yulanList))
				let routeUrl = this.$router.resolve({
					path: '/yulan',
				})
				window.open(routeUrl.href, '_blank');
			},
			//获取评级列表
			getData() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPrint?pageIndex=" + pageIndex + '&pageSize=' +
						this.pageSize + '&QRFont=' + this.QRFont,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.pageTotal = res.data.Count
					this.pingjiList = res.data.Data
					this.pingjiList.forEach((x) => {
						if (x.Star == 1) {
							x.isStar = '是'
						} else {
							x.isStar = '否'
						}
						axios({
							method: 'get',
							url: this.$store.state.pcurl + 'GetCollectiblesPoolModel?Id=' +
								x.Id,
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							x.QRFont = res.data.Data.QRFont
						})
					})
				})

			},
			//搜索
			handleSearch() {
				this.pingjiList = []
				this.pageIndex = 1
				this.getData()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看'
				this.ruleForm = row
				this.isPrint = true
				this.isdisabled = true
			}
		}
	};
</script>

<style scoped lang="less">
	:deep(.el-upload) {
		width: 56px !important;
		height: 32px;
		border: none;
		line-height: 0;
		margin-left: 50px;
	}

	:deep(.el-image) {
		display: block !important;
		margin-bottom: 30px;
		text-align: center;
	}

	:deep(.el-image__inner) {
		width: 50%;
	}

	.scorro {
		height: 500px;
		overflow: auto;
		border: 3px solid #f5f7fa;
	}

	:deep(.el-upload-list) {
		height: 0px !important;
	}

	.el-select {
		width: 300px;
		margin-right: 10px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(.el-form-item__label) {
		width: 120px !important;
	}

	:deep(.el-form-item__content) {
		margin-left: 120px !important;
	}
</style>
